import { RouteComponentProps } from 'react-router';
import authPageStyle from 'acscp/components/pages/authPage.module.scss';
import { JetPortalWelcome } from 'acscp/components/auth/jetPortalWelcome';
import classNames from 'classnames';
import { ForgotPasswordLinkPlacement, LoginForm } from 'acscp/components/auth/loginForm';
import { Link } from 'react-router-dom';
import formStyle from 'acscp/components/common/form.module.scss';
import { defineMessages, FormattedMessage } from 'react-intl';
import { RequestLoyaltySchemeAccountForm } from 'acscp/components/auth/requestLoyaltySchemeAccountForm';
import { LoyaltySchemeFeatures } from 'acscp/components/auth/features/loyaltySchemeFeatures';
import React from 'react';
import { withAnonymousUserLayout } from 'acscp/components/layout/anonymousUserLayout';
import { connect } from 'react-redux';
import {
    AuthPageProps,
    mapStateToAuthPageProps
} from 'acscp/components/pages/authPage';
import { LoginPageVariant } from 'acscp/store/loginPageVariant';

const messages = defineMessages({
    welcome: {
        id: 'web.components.pages.loginOrRequestLoyaltySchemeAccount.welcome',
        defaultMessage: 'Welcome to the ACS Loyalty Scheme.'
    },
    loginDescription: {
        id: 'web.components.pages.loginOrRequestLoyaltySchemeAccount.loginDescription',
        defaultMessage: 'If you are already a member, please login to view your current points total and view the ' +
            'selection of available gifts.'
    }
});

type LoginOrRequestLoyaltySchemeAccountProps = AuthPageProps & {
    showLoginForm: boolean;
    showRequestAccountForm: boolean;
};

export class LoginOrRequestLoyaltySchemeAccountPagePresentational
    extends React.Component<LoginOrRequestLoyaltySchemeAccountProps> {

    private redirectIfLoggedIn(): void {
        if (this.props.isLoggedIn) {
            this.props.history.push('/loyalty');
        }
    }

    componentDidMount(): void {
        this.redirectIfLoggedIn();
    }

    componentDidUpdate(): void {
        this.redirectIfLoggedIn();
    }

    render(): JSX.Element {
        return (
            <div className={authPageStyle.LoginOrCreateAccountScreen}>
                <div className={authPageStyle.welcomeWrapper}>
                    <JetPortalWelcome welcomeMessage={messages.welcome} />
                </div>
                <div
                    className={classNames(
                        authPageStyle.pageContainer, authPageStyle.pageContainerResponsive, authPageStyle.noWelcomeMessage)}
                >
                    <div className={classNames(authPageStyle.formsContainer)}>
                        {this.props.showLoginForm && (
                            <LoginForm
                                location={this.props.location}
                                loginPageVariant={LoginPageVariant.LoyaltyScheme}
                                showLoginHeader={true}
                                introText={messages.loginDescription}
                                forgotPasswordLinkPlacement={ForgotPasswordLinkPlacement.Bottom}
                                showContinueAsGuest={false}
                                underFormContent={(
                                    <Link to={'/request-account-my-rewards'} className={formStyle.FormButton}>
                                        <FormattedMessage
                                            id={'web.components.pages.loginOrRequestLoyaltySchemeAccount.becomeAMemberButton'}
                                            defaultMessage={'BECOME A MEMBER'}
                                        />
                                    </Link>
                                )}
                            />
                        )}
                        {this.props.showRequestAccountForm && <RequestLoyaltySchemeAccountForm />}
                    </div>
                    <div className={authPageStyle.featuresWrapper}>
                        <LoyaltySchemeFeatures />
                    </div>
                </div>
            </div>
        );
    }
}

const LoginOrRequestLoyaltySchemeAccountComponent = withAnonymousUserLayout(
    connect(mapStateToAuthPageProps)(
        LoginOrRequestLoyaltySchemeAccountPagePresentational
    )
);

const LoyaltySchemeLogin: React.FC<RouteComponentProps<any>> = props => (
    <LoginOrRequestLoyaltySchemeAccountComponent
        showLoginForm={true}
        showRequestAccountForm={false}
        {...props}
    />
);

const LoyaltySchemeRequestAccount: React.FC<RouteComponentProps<any>> = props => (
    <LoginOrRequestLoyaltySchemeAccountComponent
        showLoginForm={false}
        showRequestAccountForm={true}
        {...props}
    />
);

export { LoyaltySchemeLogin, LoyaltySchemeRequestAccount };
